define(function(require,exports,module){
    var baseDims  = require( '../enums/baseDims' ),
        gcd = require( '../math/gcd' ),
        merge = require( "./merge" ),
        feetDashInches = require('../math/feetDashInches');

    function Scaler(w, overrides){
    	merge(this,overrides || {});
        w=w||this.base_width;

    	var h=w/this.base_width*this.base_height,
            mindims = gcd(this.base_width, this.base_height),
            minbase = gcd(baseDims.width, baseDims.height),
            clip = this.clip;

        var relativeXScale = (this.pixelFoot / this.base_width),
            relativeYScale = (this.pixelFoot / this.base_height),
            ratioAdjustX = 1 - (baseDims.width - this.base_width) / baseDims.width,
            ratioAdjustY = 1 - (baseDims.height - this.base_height) / baseDims.height,
            x = relativeXScale * w,
            y = relativeYScale * h,
            bounds,
            fullBounds = {
                left : 0,
                right: w,
                top  : 0,
                bottom: h
            };

        this.viewBottomMargin = this.viewBottomMargin / this.base_height * h;
        this.x_offset = this.x_offset / this.base_width * w;
        this.y_offset = this.y_offset / this.base_height * h;


        if(clip && clip.width && clip.height){

            var centerx = w * this.x_center,
                centery = h * this.y_center + this.viewBottomMargin/2,

                xbound = (clip.width * this.canvasDensity  || w)/2;
                ybound = (clip.height * this.canvasDensity || h)/2;

            bounds = {
                left : centerx - xbound,
                right: centerx + xbound,
                top  : centery - ybound,
                bottom:centery + ybound,
            };
        }else{
            bounds = fullBounds;
        }
        /*  Original value matrix :
         Android -  ppf ~= 51 @ 620px
         iPad  -    ppf  = 75 @ 1024px
         */
        this.minHeight = h/w*100;
        this.relativeXScale= relativeXScale;
        this.relativeYScale = relativeYScale;
        this.fakeBallSize =  ( this.ballSize / this.foot / 2) * y;
        this.ballRadius = (this.ballSize / this.foot / 2) * x;
        this.fakeDirtCloudSize = {
            width: (this.dirtCloud.width / this.pixelFoot / 2) * y,
            height: (this.dirtCloud.height / this.pixelFoot / 2) * y
        }
        // this.eyetoScreen = this.eyetoScreen / this.base_width * w;
        // View Restrictions
        this.YOffsetViewBottomMargin = 0;//interpolatedPlateWidth/704*h,//40.0;
        // 3D Camera Simulation
        // Need to move things down in the view
        this.YOffset = (200 / this.base_height) * h;//60.0 * y;
        // 2D pitch from device gameday...
        this.x = x;
        this.y = y;
        this.bounds= bounds;
        this.fullBounds= fullBounds;
        this.width = w;
        this.height = h;

        this.maxlinewidth = this.fakeBallSize * 2;
        // this.viewBottomMargin = this.viewBottomMargin / this.base_height * 100 / ratioAdjustY;
        // this.batterScale = 5.917 * relativeYScale;

        this.batterX = (this.batterX / ratioAdjustX);

        // this.batterTop = this.batterTop * baseDims.height / this.base_height * 100;
        // this.batterLR = this.batterLR * baseDims.height / this.base_height * 100;

        this.batterLR = ( this.batterLR) /ratioAdjustX;
        this.batterTop = this.batterTop / ratioAdjustY;

        this.szBorder = this.szBorder / this.base_width * w;
        this.szPadding= this.szPadding / this.base_width * w;
        this.hotColdZoneGridStroke =  this.hotColdZoneGridStroke * (this.canvasDensity > 1 ? this.canvasDensity : 1)

    }
    Scaler.prototype =  require( '../enums/config' );
    return Scaler;
});
